export default {
  加载中: '加载中',
  发布时间_filter: '发布时间',
  国外_filter: '国外',
  国内_filter: '国内',
  展开筛选: '展开筛选',
  收起筛选: '收起筛选',
  清除筛选: '清除筛选',
  已选条件: '已选条件',
  行业分类: '行业分类',
  展览地区: '展览地区',
  举办日期: '举办日期',
  会议地区: '会议地区',
  角色类型: '角色类型',
  头条分类: '头条分类',
}
